
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import { City } from '@/common/interface/shop';
import lazyInject from '@/di';
import OrderService from '@/services/order.service';
import InsuranceDrawer from './components/InsuranceDrawer.vue';
import InsuranceService from '@/services/insurance.service';
import moment from 'moment';
import { CInsurance } from '@/models/order.model';
import { AuthEnum } from '@/services/permission.service';

enum SettlementStatus {
  NotTransferred = '未转账',
  TransferSuccess = '转账成功',
  TransferFailed = '转账失败',
  Transferring = '转账中',
}

@Component({
  components: {
    InsuranceDrawer,
  },
})
export default class InsuranceSettlement extends Vue {
  @lazyInject(OrderService)
  orderService!: OrderService;

  @lazyInject(InsuranceService)
  insuranceService!: InsuranceService;

  @Ref('insuranceDrawer')
  insuranceDrawer!: InsuranceDrawer;

  AuthEnum = AuthEnum;

  settlementStatus = SettlementStatus;

  moment = moment;

  settlementList = [
    {
      value: 1,
      label: '未转账',
    },
    {
      value: 2,
      label: '转账成功',
    },
    {
      value: 3,
      label: '转账失败',
    },
    {
      value: 4,
      label: '转账中',
    },
  ];

  form: any = {
    stetus: undefined,
    billNo: '',
    billDateStart: '',
    billDateEnd: '',
    shopName: '',
    poi: '',
    transferNo: '',
    policyNo: '',
    payFlowNo: '',
    cityId: '',
  };

  citys: any = [];

  pagination = {
    total: 10,
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
    onChange: this.onChange,
    showTotal: (total: any) => `共 ${total} 条`,
  };

  columns = [
    {
      title: '保单号',
      key: 'policyNo',
      dataIndex: 'policyNo',
      width: 200,
      align: 'center',
    },
    {
      title: '城市',
      key: 'cityName',
      dataIndex: 'cityName',
      width: 90,
      align: 'center',
    },
    {
      title: '门店POI',
      key: 'poi',
      dataIndex: 'poi',
      width: 140,
      align: 'center',
    },
    {
      title: '门店名称',
      key: 'shopName',
      dataIndex: 'shopName',
      width: 200,
      align: 'center',
    },
    {
      title: '服务内容',
      key: 'serviceName',
      dataIndex: 'serviceName',
      width: 120,
      align: 'center',
    },
    {
      title: '保险结算金额',
      key: 'settleAmount',
      dataIndex: 'settleAmount',
      width: 120,
      align: 'center',
    },
    {
      title: '结算时间',
      key: 'settleDate',
      dataIndex: 'settleDate',
      width: 200,
      align: 'center',
    },
    {
      title: '转账流水号',
      key: 'transferNo',
      dataIndex: 'transferNo',
      width: 220,
      align: 'center',
    },
    {
      title: '支付宝流水号',
      key: 'payFlowNo',
      dataIndex: 'payFlowNo',
      width: 220,
      align: 'center',
    },
    {
      title: '结算状态',
      key: 'status',
      dataIndex: 'status',
      width: 90,
      align: 'center',
    },
    {
      title: '操作',
      key: 'action',
      width: 180,
      fixed: 'right',
      align: 'center',
      scopedSlots: { customRender: 'action' },
    },
  ];

  listData: any = [];

  stetusList = [
    {
      label: '未转账',
      value: 0,
    },
    {
      label: '已转账',
      value: 1,
    },
    {
      label: '转账中',
      value: 2,
    },
    {
      label: '转账失败',
      value: 3,
    },
  ];

  @Watch('$route')
  handleSearch() {
    const {
      page,
      pageSize,
      shopName,
      status,
      billDateStart,
      billDateEnd,
      serviceName,
      poi,
      cityId,
      policyNo,
      billNo,
      transferNo,
      payFlowNo,
    } = this.$route.query;
    const query: any = {
      page: page || 1,
      pageSize: pageSize || this.pagination.pageSize,
    };
    if (cityId) {
      query.city_id = cityId;
      this.form.cityId = +cityId;
    }
    if (shopName) {
      query.shop_name = shopName;
      this.form.shopName = shopName;
    }
    if (status !== undefined) {
      query.status = status;
      this.form.status = +status;
    }
    if (billDateStart) {
      query.bill_date_start = billDateStart;
      this.form.billDateStart = billDateStart;
    }
    if (billDateEnd) {
      query.bill_date_end = billDateEnd;
      this.form.billDateEnd = billDateEnd;
    }
    if (serviceName) {
      query.serviceName = serviceName;
      this.form.serviceName = serviceName;
    }
    if (poi) {
      query.poi = poi;
      this.form.poi = poi;
    }
    if (policyNo) {
      query.policy_no = policyNo;
      this.form.policyNo = policyNo;
    }
    if (billNo) {
      query.bill_no = billNo;
      this.form.billNo = billNo;
    }
    if (transferNo) {
      query.transfer_no = transferNo;
      this.form.transferNo = transferNo;
    }
    if (payFlowNo) {
      query.pay_flow_no = payFlowNo;
      this.form.payFlowNo = payFlowNo;
    }
    console.log(this.form);
    this.getList(query);
  }

  async getList(query: any) {
    const res = await this.insuranceService.getInsuranceSettlementList(query);
    console.log(res);
    if (res) {
      this.listData = res.list.map((data: any) => {
        console.log(data);
        return CInsurance.from(data);
      });
      console.log(this.listData);
      this.pagination.total = res.total;
    } else {
      this.listData = [];
      this.pagination.total = 0;
    }
  }

  /** 省市过滤 */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  regionFilterOption(input: string, option: any) {
    return (
      option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    );
  }

  async getCityList() {
    const response = (await this.orderService.getCityList()) as unknown as {
      [key: string]: {
        province: City;
        city: City[];
      };
    };
    if (response) {
      const citys = Object.values(response)
        .map((item) => item.city)
        .reduce((prev, cur) => prev.concat(cur), []);
      this.citys = citys;
    } else {
      this.citys = [];
    }
  }

  lookDetail(val: any) {
    this.insuranceDrawer.init(val);
  }

  async settlementRetry(val: any) {
    this.$confirm({
      title: '提示',
      content: '确定重新转账吗？',
      okText: '确定',
      cancelText: '取消',
      onOk: async () => {
        const res = await this.insuranceService.getInsuranceSettlementRetry(
          val.transferNo,
        );
        if (res) {
          this.$message.success(res);
        }
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  search() {
    this.pagination.current = 1;
    this.assembleRouting();
  }

  reset() {
    this.form = {
      cityName: '',
      shopName: '',
      status: undefined,
      billDateStart: '',
      billDateEnd: '',
      serviceName: '',
      poi: '',
      cityId: undefined,
      policyNo: '',
      billNo: '',
      transferNo: '',
      payFlowNo: '',
    };
    this.pagination.current = 1;
    this.assembleRouting();
  }

  assembleRouting() {
    const { current, pageSize } = this.pagination;
    const query: any = {
      page: current,
      pageSize,
      timestamp: `${Math.round(Date.now() / 1000)}`,
    };
    const {
      cityName,
      shopName,
      status,
      billDateStart,
      billDateEnd,
      serviceName,
      poi,
      cityId,
      policyNo,
      billNo,
      transferNo,
      payFlowNo,
    } = this.form;
    if (cityName) {
      query.cityName = cityName;
    }
    if (shopName) {
      query.shopName = shopName;
    }
    if (status !== undefined) {
      query.status = status;
    }
    if (billDateStart) {
      query.billDateStart = billDateStart;
    }
    if (billDateEnd) {
      query.billDateEnd = billDateEnd;
    }
    if (serviceName) {
      query.serviceName = serviceName;
    }
    if (poi) {
      query.poi = poi;
    }
    if (cityId) {
      query.cityId = cityId;
    }
    if (policyNo) {
      query.policyNo = policyNo;
    }
    if (billNo) {
      query.billNo = billNo;
    }
    if (transferNo) {
      query.transferNo = transferNo;
    }
    if (payFlowNo) {
      query.payFlowNo = payFlowNo;
    }
    this.$router.push({
      query,
    });
  }

  onChange(page: any) {
    this.pagination.current = page;
    this.assembleRouting();
  }

  onShowSizeChange(current: any, pageSize: any) {
    this.pagination.current = current;
    this.pagination.pageSize = pageSize;
    this.assembleRouting();
  }

  refresh() {
    this.assembleRouting();
  }

  onChangeCreateTime(value: any) {
    this.form.billDateStart = value[0] ? value[0].format('YYYY-MM-DD') : null;
    this.form.billDateEnd = value[1] ? value[1].format('YYYY-MM-DD') : null;
  }

  mounted() {
    this.getCityList();
    this.handleSearch();
  }
}
